'use client';

import {retryPromise} from '@utils/retryPromise';
import dynamic from 'next/dynamic';
import 'swiper/css';
import 'swiper/css/navigation';

import {ScreenshotsModalProps} from './types';

const LazyImplementation = dynamic(
  retryPromise(
    () => import(/* webpackChunkName: "screenshotsModal" */ './parts/Modal'),
    {fallback: {default: () => <></>}},
  ),
  {
    ssr: false,
  },
);

export default function ScreenshotsModal(props: ScreenshotsModalProps) {
  if (!props.isOpen) {
    // свайпер + хедлесс юай = дорого, поэтому заранее не маунтим
    return null;
  }
  return <LazyImplementation {...props} />;
}
